// PerformanceChart.js
import React , { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
//import DOMPurify from 'dompurify';
//import './PerformanceChart.css';

const PerformanceChart = ({ salesChannel, seoName, datasourceId, language, webApiURL, dateFormat = 'dd-MM-yy', currency = '&nbsp;&euro;', decimalSeparator = ',' }) => {
	const { t } = useTranslation();
	
	useEffect(() => {
		window.applicationReInit(['PerformanceChart']);
	}, []);
	
	const dataParam = JSON.stringify({
		SalesChannel: salesChannel,
		SeoName: seoName,
		DatasourceId: datasourceId,
		Language: language,
	  });

	const handlebarsTemplate = `
		<a name="Performance"></a>
		<div class="l-container l-container--no-gutters">
			<div class="js-line-chart l-grid u-margin-top-xl u-margin-bottom-xl">
				<div class="l-grid__row">
					<div class="l-grid__column-12 u-text-align-center" tabindex="0">
						<h2 class="c-heading u-margin-bottom-2xs" tabindex="0">
							{{Title}}
							{{#if ComponentTitleDisclaimerSubScriptValue}}
							<sup class="superscript">{{{ComponentTitleDisclaimerSubScriptValue}}}</sup>
							{{/if}}
							{{#if PerfAsOfDate}}
							<p class="c-copy u-margin-bottom-3m u-text-weight-light" tabindex="0">
								${t('asOfDateLabel')} {{{PerfAsOfDate}}}
							</p>
							{{/if}}
							<p class="c-copy u-margin-bottom-3m u-text-weight-light u-hidden-small">
								${t('selectPeriod')}
							</p>
						</h2>

					</div>


					<div class="l-grid__column-12 u-text-align-center u-margin-bottom-2m u-hidden-medium-up">
						<div class="c-select js-select c-natural-language-form__form-body__selector c-natural-language-form__form-body__selector--long js-natural-form-selector-handler">
							<select class="c-select__natural"
									name="select-1"
									aria-hidden="false"
									data-label="${t('selectPeriod')}"
									id="dropdown-overview-1">
								{{#if perfYTD}}
								<option value="YTD" class="ytd"
										id="dropdown-overview-1-option-1">
									${t('periodYTD')}
								</option>
								{{/if}}
								{{#if perf1M}}
								<option value="1M" class="1m"
										id="dropdown-overview-1-option-2">
									${t('period1M')}
								</option>
								{{/if}}
								{{#if perf3M}}
								<option value="3M" class="3m"
										id="dropdown-overview-1-option-5">
										${t('period3M')}
								</option>
								{{/if}}
								{{#if perf6M}}
								<option value="6M" class="6m"
										id="dropdown-overview-1-option-6">
										${t('period6M')}
								</option>
								{{/if}}
								{{#if perf1Y}}
								<option value="1Y" class="1y"
										id="dropdown-overview-1-option-7">
										${t('period1Y')}
								</option>
								{{/if}}
								{{#if perf3Y}}                          
								<option value="3Y" class="3y"
										id="dropdown-overview-1-option-8">
										${t('period3Y')}
								</option>
								{{/if}}
								{{#if perf5Y}}
								<option value="5Y" class="5y"
										id="dropdown-overview-1-option-9">
										${t('period5Y')}
								</option>
								{{/if}}
								{{#if perfSinceIncept}}
								<option value="ALL" class="all"
										id="dropdown-overview-1-option-9">
									${t('periodSinceInc')}
								</option>
								{{/if}}
							</select>
						</div>
					</div>



					<div class="l-grid__column-12 u-text-align-center u-margin-bottom-2m u-hidden-small">
						<div class="u-flex justify-content-center">
							<form>
								<div class="c-radio-toggle c-radio-toggle--small c-radio-toggle--medium-condensed">
									{{#if perfYTD}}
									<input id="return-range-ytd" class="c-radio__input" name="range" type="radio"
										value="YTD" aria-selected="true">
									<label for="return-range-ytd" class="c-radio__label u-margin-left-md ytd">
										${t('periodYTD')}
									</label>
									{{/if}}
									{{#if perf1M}}
									<input id="return-range-month" class="c-radio__input" name="range" type="radio"
										value="1M" aria-selected="true">
									<label for="return-range-month" class="c-radio__label u-margin-left-md 1m">
										${t('period1M')}
									</label>
									{{/if}}
									{{#if perf3M}}
									<input id="return-range-three-month" class="c-radio__input" name="range" type="radio"
										value="3M" aria-selected="true">
									<label for="return-range-three-month" class="c-radio__label u-margin-left-md 3m">
										${t('period3M')}
									</label>
									{{/if}}
									{{#if perf6M}}
									<input id="return-range-six-month" class="c-radio__input" name="range" type="radio"
										value="6M" aria-selected="true">
									<label for="return-range-six-month" class="c-radio__label u-margin-left-md 6m">
										${t('period6M')}
									</label>
									{{/if}}
									{{#if perf1Y}}
									<input id="return-range-year" class="c-radio__input" name="range" type="radio" value="1Y" aria-selected="true">
									<label for="return-range-year" class="c-radio__label u-margin-left-md 1y">
										${t('period1Y')}
									</label>
									{{/if}}
									{{#if perf3Y}}
									<input id="return-range-three-year" class="c-radio__input" name="range" type="radio" value="3Y" aria-selected="true">
									<label for="return-range-three-year" class="c-radio__label u-margin-left-md 3y">
										${t('period3Y')}
									</label>
									{{/if}}
									{{#if perf5Y}}
									<input id="return-range-five" class="c-radio__input" name="range" type="radio" value="5Y" aria-selected="true">
									<label for="return-range-five" class="c-radio__label u-margin-left-md 5y">
										${t('period5Y')}
									</label>
									{{/if}}
									{{#if perfSinceIncept}}
									<input id="return-range-all" class="c-radio__input" name="range" checked="checked" type="radio" value="ALL" aria-selected="true">
									<label for="return-range-all" class="c-radio__label u-margin-left-md all">
										${t('periodSinceInc')}
									</label>
									{{/if}}
								</div>
							</form>
						</div>
					</div>

					{{#if perf3Y}}
					<div class="c-tile-content l-grid__column-medium-4 offset-medium-2 u-margin-bottom-2m overall 3y">
						<p class="c-copy u-text-align-center u-text-weight-normal c-fund-header__copy--categoryinfo" tabindex="0">
							${t('annualPerf')}
						</p>
						<span class="c-copy">
							<h4 class="c-heading u-text-align-center u-text-weight-semibold c-link--inline" tabindex="0">
								{{perf3YPA}}%<span class="c-fund-summary-banner__currency"> </span>
							</h4>
						</span>
					</div>
					{{/if}}
					{{#if perf3YPA}}
					<div class="c-tile-content l-grid__column-medium-4 u-margin-bottom-2m overall 3y">
						<p class="c-copy u-text-align-center u-text-weight-normal c-fund-header__copy--categoryinfo" tabindex="0">
							${t('overallPerf')}
						</p>
						<span class="c-copy">
							<h4 class="c-heading u-text-align-center u-text-weight-semibold c-link--inline" tabindex="0">
								{{perf3Y}}% <span class="c-fund-summary-banner__currency"> </span>
							</h4>
						</span>
					</div>
					{{/if}}
					{{#if perf5Y}}
					<div class="c-tile-content l-grid__column-medium-4 offset-medium-2 u-margin-bottom-2m overall 5y">
						<p class="c-copy u-text-align-center u-text-weight-normal c-fund-header__copy--categoryinfo" tabindex="0">
							${t('annualPerf')}
						</p>
						<span class="c-copy">
							<h4 class="c-heading u-text-align-center u-text-weight-semibold c-link--inline" tabindex="0">
								{{perf5YPA}}%<span class="c-fund-summary-banner__currency"> </span>
							</h4>
						</span>
					</div>
					{{/if}}
					{{#if perf5YPA}}
					<div class="c-tile-content l-grid__column-medium-4 u-margin-bottom-2m overall 5y">
						<p class="c-copy u-text-align-center u-text-weight-normal c-fund-header__copy--categoryinfo" tabindex="0">
							${t('overallPerf')}
						</p>
						<span class="c-copy">
							<h4 class="c-heading u-text-align-center u-text-weight-semibold c-link--inline" tabindex="0">
								{{perf5Y}}% <span class="c-fund-summary-banner__currency"> </span>
							</h4>
						</span>
					</div>
					{{/if}}
					{{#if perfSinceIncept}}
					<div class="c-tile-content l-grid__column-medium-4 offset-medium-2 u-margin-bottom-2m overall incep">
						<p class="c-copy u-text-align-center u-text-weight-normal c-fund-header__copy--categoryinfo" tabindex="0">
							${t('annualPerf')}
						</p>
						<span class="c-copy">
							<h4 class="c-heading u-text-align-center u-text-weight-semibold c-link--inline" tabindex="0">
								{{perfSinceInceptPA}}%<span class="c-fund-summary-banner__currency"> </span>
							</h4>
						</span>
					</div>
					{{/if}}
					{{#if perfSinceInceptPA}}
					<div class="c-tile-content l-grid__column-medium-4 u-margin-bottom-2m overall incep">
						<p class="c-copy u-text-align-center u-text-weight-normal c-fund-header__copy--categoryinfo" tabindex="0">
							${t('overallPerf')}
						</p>
						<span class="c-copy">
							<h4 class="c-heading u-text-align-center u-text-weight-semibold c-link--inline" tabindex="0">
								{{perfSinceIncept}}% <span class="c-fund-summary-banner__currency"> </span>
							</h4>
						</span>
					</div>
					{{/if}}
					{{#if perfYTD}}
					<div class="c-tile-content l-grid__column-12 performance ytd">
						<p class="c-copy u-text-align-center u-text-weight-normal c-fund-header__copy--categoryinfo" tabindex="0">
							${t('overallPerf')}
						</p>
						<span class="c-copy">
							<h4 class="c-heading u-text-align-center u-text-weight-semibold c-link--inline" tabindex="0">
								{{perfYTD}}%<span class="c-fund-summary-banner__currency"> </span>
							</h4>
						</span>
					</div>
					{{/if}}
					{{#if perf1M}}
					<div class="c-tile-content l-grid__column-12 performance 1m">
						<p class="c-copy u-text-align-center u-text-weight-normal c-fund-header__copy--categoryinfo" tabindex="0">
							${t('overallPerf')}
						</p>
						<span class="c-copy">
							<h4 class="c-heading u-text-align-center u-text-weight-semibold c-link--inline" tabindex="0">
								{{perf1M}}%<span class="c-fund-summary-banner__currency"> </span>
							</h4>
						</span>
					</div>
					{{/if}}
					{{#if perf3M}}
					<div class="c-tile-content l-grid__column-12 performance 3m">
						<p class="c-copy u-text-align-center u-text-weight-normal c-fund-header__copy--categoryinfo" tabindex="0">
							${t('overallPerf')}
						</p>
						<span class="c-copy">
							<h4 class="c-heading u-text-align-center u-text-weight-semibold c-link--inline" tabindex="0">
								{{perf3M}}%<span class="c-fund-summary-banner__currency"> </span>
							</h4>
						</span>
					</div>
					{{/if}}
					{{#if perf6M}}
					<div class="c-tile-content l-grid__column-12 performance 6m">
						<p class="c-copy u-text-align-center u-text-weight-normal c-fund-header__copy--categoryinfo" tabindex="0">
							${t('overallPerf')}
						</p>
						<span class="c-copy">
							<h4 class="c-heading u-text-align-center u-text-weight-semibold c-link--inline" tabindex="0">
								{{perf6M}}%<span class="c-fund-summary-banner__currency"> </span>
							</h4>
						</span>
					</div>
					{{/if}}
					{{#if perf1Y}}
					<div class="c-tile-content l-grid__column-12 performance 1y">
						<p class="c-copy u-text-align-center u-text-weight-normal c-fund-header__copy--categoryinfo" tabindex="0">
							${t('overallPerf')}
						</p>
						<span class="c-copy">
							<h4 class="c-heading u-text-align-center u-text-weight-semibold c-link--inline" tabindex="0">
								{{perf1Y}}%<span class="c-fund-summary-banner__currency"> </span>
							</h4>
						</span>
					</div>
					{{/if}}
					{{#if InProxDisclosures}}
					<div class="l-grid__column-large-8 offset-large-1 u-margin-bottom-2m">
						{{#each InProxDisclosures}}
						<div class="in-proximity-disclaimers note-one">
							<sup>{{{Key}}}</sup>
							<span>{{{Value}}}</span>
						</div>
						{{/each}}
					</div>
					{{/if}}

					<div class="l-grid__column-12">
						<div data-line-chart-container></div>
					</div>

					{{#if DisclaimerText}}
					<div class="c-copy u-margin-bottom-3m u-text-weight-light u-margin-left-lg" tabindex="0">
						<div class="c-copy c-copy--small u-margin-top-2m" tabindex="0">
							{{{DisclaimerText}}}
						</div>
					</div>
					{{/if}}

				</div>
			</div>
		</div>
	`;

	let baseUrl = process.env.REACT_APP_DATA_URL  || '#{DATA_URL}';

    return (
		<>
			<div
				className="m-fund-returns-line-chart m-fund-us-returns-line-chart"
				data-param={dataParam}
				data-url={`${baseUrl}${webApiURL}`}
				data-method="post"
				data-component="fund-performance"
				data-date-format={dateFormat}
				data-currency={currency}
				data-module="FundUsReturnsLineChart"
				data-decimalseparator={decimalSeparator}
				data-inception-date-text={t('dataInceptionDateText')}>
			</div>
			<script 
				id="linechart-return-us-template" 
				type="text/x-handlebars-template" 
				dangerouslySetInnerHTML={{ __html: handlebarsTemplate }}
			/>
		</>
    );
};

export default PerformanceChart;